var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.98438 10.5H10.7153",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34634 1.8266C8.55545 1.61748 8.83908 1.5 9.13482 1.5C9.28125 1.5 9.42625 1.52884 9.56154 1.58488C9.69683 1.64092 9.81975 1.72305 9.9233 1.8266C10.0268 1.93014 10.109 2.05307 10.165 2.18836C10.2211 2.32365 10.2499 2.46865 10.2499 2.61508C10.2499 2.76152 10.2211 2.90652 10.165 3.0418C10.109 3.17709 10.0268 3.30002 9.9233 3.40356L3.35262 9.97424L1.25 10.4999L1.77565 8.39728L8.34634 1.8266Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.db1815a66c6c804305ea55ad11b567bb.svg";
export { ForwardRef as ReactComponent };